module.exports = __webpack_public_path__ + "img/Ukraine.b54b0bb8.svg";